import { JwtUtil } from '@Shared/utils';
import { EntitlementDecoded } from '../_models';
import { OnLegacyEntitlementsReadyEvent } from '@Modules/event_module';
import { LoggerService } from '@Shared/logger';
import { APP_EVENTS } from '@Core';

export class EntitlementUtils {
  private static Logger = LoggerService.createLogger('EntitlementUtils');

  static decodeEntitlementToken(jwt): EntitlementDecoded {
    return JwtUtil.decodeToken(jwt) as EntitlementDecoded;
  }

  static validateEntitlementToken(): boolean {
    return false; //TODO: Implement validation
  }

  static fireLegacyEntitlementsReadyEvent(jwt?: string | false): void {
    const details: OnLegacyEntitlementsReadyEvent = {
      token: jwt || false,
    };

    try {
      if (jwt) {
        const decoded = this.decodeEntitlementToken(jwt);
        details.isEntitled = decoded.entitlement_entitled;
        details.adfree = decoded.entitlement_extras_adfree || false;
        details.subscriptionLevel = decoded.entitlement_level;
      }

      EntitlementUtils.Logger.trace(
        'Firing legacy entitlementsReady event',
        details,
      );

      window.dispatchEvent(
        new CustomEvent(APP_EVENTS.onLegacyEntitlementsReady, {
          detail: details,
        }),
      );
    } catch (_) {
      details.isEntitled = 'unknown';
      details.adfree = 'unknown';
      details.subscriptionLevel = 'unknown';

      // fire empty entitlementsReady event if there is an error
      EntitlementUtils.Logger.trace(
        'Firing legacy entitlementsReady event with `unknown` values:',
        details,
      );

      window.dispatchEvent(
        new CustomEvent(APP_EVENTS.onLegacyEntitlementsReady, {
          detail: details,
        }),
      );
    }
  }
}
